import React from "react";

function HTMLRenderer({ content, className }) {
  return (
    <span className={className} dangerouslySetInnerHTML={{ __html: content }} />
  );
}

export default HTMLRenderer;
